import { initScrollListener } from "@/core/scroll"
import { initializeScene } from "./scene"

const HUMAN_HEAD_DIAMETER = 0.175 // m
const EARTH_DIAMETER = 12756000 // m
const HUMAN_EARTH_RATIO = EARTH_DIAMETER / HUMAN_HEAD_DIAMETER
const ZOOM_LIMIT = 1000 * Math.log2(HUMAN_EARTH_RATIO)


// initScrollListener({ min: -ZOOM_LIMIT, init: -ZOOM_LIMIT, max: 2000 })
initScrollListener({ min: -ZOOM_LIMIT, max: 1500, init: 1500 })

const canvas = document.querySelector('#glcanvas') as HTMLCanvasElement
initializeScene(canvas)